export default class ScrollZoomAnimator {
  constructor() {
    this.elements = document.querySelectorAll('.gr-scroll-zoom img');
    if (this.elements.length) {
      this.handleScroll = this.handleScroll.bind(this);
      this.animate = this.animate.bind(this);
      this.raf = null;

      window.addEventListener('scroll', this.handleScroll);
      window.addEventListener('resize', this.handleScroll);
      this.animate(); // inicial
    }
  }

  handleScroll() {
    if (!this.raf) {
      this.raf = requestAnimationFrame(this.animate);
    }
  }

  animate() {
    const viewportHeight = window.innerHeight;

    const startZoomIn = viewportHeight * 0.2;  // empieza el zoom-in
    const holdStart = viewportHeight * 0.3;    // zona donde se mantiene
    const holdEnd = viewportHeight * 0.7;
    const endZoomOut = viewportHeight * 0.9;   // empieza el zoom-out

    const maxZoom = 1.1;
    const minZoom = 1;

    this.elements.forEach((el) => {
      const rect = el.getBoundingClientRect();
      const elCenter = rect.top + rect.height / 2;

      let scale = minZoom;

      if (elCenter >= holdStart && elCenter <= holdEnd) {
        // Centro del rango bloqueado: zoom máximo
        scale = maxZoom;
      } else if (elCenter < holdStart && elCenter >= startZoomIn) {
        // Haciendo zoom-in
        const progress = (elCenter - startZoomIn) / (holdStart - startZoomIn);
        scale = minZoom + (maxZoom - minZoom) * progress;
      } else if (elCenter > holdEnd && elCenter <= endZoomOut) {
        // Haciendo zoom-out
        const progress = 1 - ((elCenter - holdEnd) / (endZoomOut - holdEnd));
        scale = minZoom + (maxZoom - minZoom) * progress;
      } else {
        // Fuera de zona activa (encima o muy abajo): zoom mínimo
        scale = minZoom;
      }

      el.style.transform = `scale(${scale})`;
      el.style.transition = 'transform 0.3s ease-out';
    });

    this.raf = null;
  }
}
